export function parseDisabledIds(value: string | null | undefined): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
}

export function serializeDisabledIds(ids: string[]): string {
  return Array.from(new Set(ids)).join(',');
}

export function deriveIsEnabled(
  conversationAssigneeGroupId: string,
  disabledIds: Set<string>,
  pending?: boolean,
): boolean {
  if (pending !== undefined) return pending;
  return !disabledIds.has(conversationAssigneeGroupId);
}

export function computeNextDisabledCsv(
  currentValue: string | null | undefined,
  conversationAssigneeGroupId: string,
  shouldBeEnabled: boolean,
): string {
  const current = new Set(parseDisabledIds(currentValue));
  if (shouldBeEnabled) {
    current.delete(conversationAssigneeGroupId);
  } else {
    current.add(conversationAssigneeGroupId);
  }
  return serializeDisabledIds(Array.from(current));
}
